import { publicJson } from './client';
import { API_ROUTES, buildOpeningsQuery } from '../../../shared/api';
import type {
  Line,
  Opening,
  OpeningFilters,
  OpeningSearchParams,
  OpeningsResponse,
} from '../../../shared/types';

/**
 * The opening catalog is static and public, so responses are cached in memory
 * for the life of the tab. Opening detail in particular is several hundred
 * kilobytes of theory and move lists, and users flick back and forth between
 * the browse list and a detail page constantly.
 */
const openingCache = new Map<string, Opening>();
let filtersCache: OpeningFilters | null = null;

export const openingsApi = {
  list: (params: OpeningSearchParams) =>
    publicJson<OpeningsResponse>(`${API_ROUTES.openings}${buildOpeningsQuery(params)}`),

  async get(id: string): Promise<Opening> {
    const cached = openingCache.get(id);
    if (cached) return cached;
    const opening = await publicJson<Opening>(API_ROUTES.opening(id));
    openingCache.set(id, opening);
    return opening;
  },

  async filters(): Promise<OpeningFilters> {
    if (filtersCache) return filtersCache;
    filtersCache = await publicJson<OpeningFilters>(API_ROUTES.openingFilters);
    return filtersCache;
  },

  line: (openingId: string, lineId: string) =>
    publicJson<Line>(API_ROUTES.openingLine(openingId, lineId)),
};
